import React, { useEffect, useState } from 'react'
import { ArrowRight, X } from 'lucide-react'
import ModalTest from '../../BaseModal'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ButtonContainer, Button, CloseDiv, ContainerOfModal, Header, HeaderTitle } from '../../styles/modal-style'
import { TwoColumnLayout, MainColumn, SideColumn, Section, SectionTitle, SidebarSection, SidebarSectionTitle, SidebarButton, InputComment } from './style'
import History from './History'
import Options from './Options'
import Status from './Status'
import SimpleData from './SimpleData'
import Actions from './Actions'
import CommentsOfOp from './Comments'
import axios from 'axios'

export interface OpViewerType {
  id: number
  lastStageId: number
  currentStageId: number
  nextStageId: number
}

const ViewOPCard = () => {
  const navigate = useNavigate()
  const [ searchParams ] = useSearchParams()
  const id = searchParams.get('id')
  const [ op, setOp ] = useState<OpViewerType>({
    id: Number(id),
    currentStageId:0,
    lastStageId:0,
    nextStageId:0
  })

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/pcp/service/${id}`)
      .then(response => {
        if(response.data) {
          setOp(response.data)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }, [])
  
  return (
    <ModalTest>
      <ContainerOfModal width='50%'>
        <Header>
          <div>
            <Status />
            <HeaderTitle>OP{id}</HeaderTitle>
          </div>
          <CloseDiv onClick={() => navigate('..')}> <X size={20} /></CloseDiv>
        </Header>
        <TwoColumnLayout>
          <MainColumn>
            <SimpleData />
            <CommentsOfOp />
            <History />
          </MainColumn>
          <SideColumn>
            <Options />
            <Actions op={op} />
          </SideColumn>
        </TwoColumnLayout>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default ViewOPCard